// categoryUtil.js
// ---------------
// Category statistics and operating intermediary layer to centralize common operations

import util from "./util.js";

let app = {};

const base = {
  setVueInstance(instance) {
    app = instance;
  },
  getCategory(id) {
    return app.categories[id] || {};
  },
  getSubcategoryVisibility(categoryId) {
    return app.categories[categoryId].showChildren || false;
  },
  // FIXME - Take into account instances where we have deleted or archived categories
  getIsValidCategory(id) {
    return app.categories[id] ? true : false;
  },
  getName(id) {
    return app.categories[id].name || "";
  },
  getColor(id) {
    // Default to blue if color is somehow not defined
    return app.categories[id].color || "blue";
  },
  getLastBlockAddedTs(id, includeChildren = true) {
    let category = app.categories[id];
    let last = category.last_block_added || 0;

    if (!includeChildren) {
      return last;
    }

    Object.keys(category.children || {}).forEach(childId => {
      let child = app.categories[childId];
      last = (child.last_block_added || 0) > last ? child.last_block_added : last;
    });

    return last;
  },
  getShowChildren(id) {
    return app.categories[id].showChildren ? true : false;
  },
  // FIXME - This is confusing compared to the other methods below
  getQuota(id, date = util.getCurrentDay(), includeChildren = true) {
    let category = app.categories[id] || {};
    let total = util.isActiveDay(category.activeDays, date) ? category.quota : 0;

    if (!category.children || !includeChildren) {
      return total;
    }

    //This is a common paradigm.. simplify please
    Object.keys(category.children || {}).forEach(childId => {
      let child = app.categories[childId] || {};
      total += util.isActiveDay(child.activeDays, date) ? child.quota : 0;
    });

    return total;
  },
  getWeekQuota(id) {
    const category = app.categories[id];
    return category.quota * (category.activeDays || []).length;
  },
  // Include children in quota calculations
  getTotalWeekQuota(id) {
    const category = app.categories[id];
    let total = this.getWeekQuota(id);
    Object.keys(category.children || []).forEach(childId => {
      total += this.getWeekQuota(childId);
    });
    return total;
  },
  getCompleted(id, date = util.getCurrentDay(), includeChildren = true) {
    let category = app.categories[id];

    if (date === util.getCurrentDay()) {
      let blocks = includeChildren ? category.totalBlocks : category.blocks;
      return Object.keys(blocks || {}).length;
    } else {
      let total = category.days[date] || 0;

      if (includeChildren) {
        Object.keys(category.children || {}).forEach(childId => {
          total += app.categories[childId].days[date] || 0;
        });
      }

      return total;
    }
    //   FIXME - Handle the external blocks/not on category/loaded
    // FIXME - Load blocks we don't have in memory if they are requested
  },
  getCompletedToday(id, includeChildren = true) {
    return base.getCompleted(id, util.getCurrentDay(), includeChildren);
  },
  getTotalCompleted(id) {
    let category = this.categories[id];

    console.warn("IMPLEMENT ME");
    return 777;
  },
  getThisXSummary(durationField, id, includeChildren = true) {
    const category = app.categories[id];
    let total = category.summaries[durationField];

    if (includeChildren) {
      Object.keys(category.children || {}).forEach(childId => {
        total += app.categories[childId].summaries[durationField] || 0;
      });
    }

    return total;
  },
  getThisWeekSummary(id, includeChildren = true) {
    // return base.getThisXSummary("week", id, includeChildren);
    console.log("IMPLEMENT ME");
    return 0;
  },
  getThisMonthSummary(id, includeChildren = true) {
    return base.getThisXSummary("month", id, includeChildren);
  },
  getThisYearSummary(id, includeChildren = true) {
    return base.getThisXSummary("year", id, includeChildren);
  },
  getTotalSummary(id, includeChildren = true) {
    return base.getThisXSummary("total", id, includeChildren);
  },
  getDaySummary(id, includeChildren = true) {
    //TODO - IMPLEMENT ME
    //Return day quota, completed, and stats for children?
  },
  //TODO - UPDATE THIS EACH TIME WE ADD A NEW METHOD THAT NEEDS TO BE ACCESSED!
  getMixin() {
    return {
      methods: {
        getCategoryName: this.getName,
        getCategoryQuota: this.getQuota,
        getCategoryWeekQuota: this.getWeekQuota,
        getCategoryTotalWeekQuota: this.getTotalWeekQuota,
        getCategoryTotalSummary: this.getTotalSummary,
        getCategoryYearSummary: this.getThisYearSummary,
        getCategoryMonthSummary: this.getThisMonthSummary,
        getCategoryCompleted: this.getCompleted,
        getCategoryColor: this.getColor,
      },
    };
  },
};

export default base;



// WEBPACK FOOTER //
// ./dev/src/categoryUtil.js